var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.estimateListQuery
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_EstimateListQuery"),
                      name: "estimateListQuery"
                    }
                  },
                  [_c("estimate-list-query")],
                  1
                )
              : _vm._e(),
            _vm.billsPayable
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_BillsPayable"),
                      name: "billsPayable"
                    }
                  },
                  [_c("bills-payable-query")],
                  1
                )
              : _vm._e(),
            _vm.mappingConfiguration
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_MappingConfiguration"),
                      name: "mappingConfiguration"
                    }
                  },
                  [_c("mapping-management")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }